import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter, Link, useHistory } from "react-router-dom"
import { isEmpty, size, map } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {showSuccessToast} from "helpers/function_helper"
import ReactDrawer from 'react-drawer';
import classNames from "classnames"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
} from "reactstrap"
import RightDrawer from "../../components/Common/RightDrawer"
//redux
import { useSelector, useDispatch } from "react-redux"
import SweetAlert from "react-bootstrap-sweetalert"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { getAllProducts as onGetAllProducts } from "store/products/actions"
import { deleteItemDirect as onDeleteItemDirect } from "helpers/backend_helper"
import Loader from "components/Common/Loader"
import Lightbox from "react-image-lightbox"
import "react-image-lightbox/style.css"

const ProductList = props => {
  const history = useHistory()
  const dispatch = useDispatch()

  useEffect(() => {
    setShowLoading(true)
    dispatch(onGetAllProducts())
  }, [dispatch]);

  const { productList } = useSelector(state => ({
    productList: state.Products.products,
  }))

  useEffect(() => {
    //console.log('productList:'+productList)
    if(productList && productList.length > 0){
      
    }
    setShowLoading(false)
  }, [productList]);

  const [selectedFiles, setSelectedFiles] = useState([])
  const [isGallery, setisGallery] = useState(false)
  const [photoIndex, setphotoIndex] = useState(0)

  const [isEdit, setIsEdit] = useState(false)

  const [newItemToAdd, setNewItemToAdd] = useState()
  const [position, setPosition] = useState()
  const [open, setOpen] = useState(false)
  const [detailsForEdit, setDetailsForEdit] = useState()
  const [showDeletePopUp, setShowDeletePopUp] = useState(false)
  const [showErrorPopUp, setShowErrorPopUp] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [deleteMessage, setDeleteMessage] = useState('')
  const [itemToDelete, setItemToDelete] = useState()
  const [showLoading, setShowLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  
  function addNewItem(item) {
    setPosition('right')
    setOpen(!open)
    setNewItemToAdd(item)
  }
  const onDrawerClose = () => {
    setOpen(false);
  }
  const onNewlyAddedValue = (value) => {
  }
  
  //pagination customization
  const pageOptions = {
    sizePerPage: 10,
    totalSize: size(productList), 
    custom: true,
    onPageChange: (page, sizePerPage) => {
      setCurrentPage(page)
    }
  }
  const { SearchBar } = Search


  const ProductListColumns = () => [
    {
      dataField: "productid",
      hidden: true,
    },
    {
      dataField: "productcode",
      text: "Product Code",
      sort: true,
      sortValue: (cell, row) => {
      }
    },
    {
      dataField: "productname",
      text: "Name",
      sort: true,
      formatter: (cellContent, row) => (
        <div className="text-body fw-bold">
          {cellContent}
        </div>
      ),
    },
    {
      dataField: "productimages",
      text: "Image",
      sort: false,
      formatter: (cellContent, row) => {
        return <div className="avatar-group">
          {
            cellContent ? cellContent.map((imagename, idx) => 
              <div
                className="avatar-group-item"
                key={idx + "-file"}
              >
                <Link
                  to="#"
                  className="team-member d-inline-block"
                  id="member1"
                  onClick={(e) => {
                    e.stopPropagation()
                    setSelectedFiles(cellContent)
                    setphotoIndex(idx)
                    setisGallery(true)
                  }}
                >
                  <img
                    src={imagename}
                    className="rounded-circle avatar-xs"
                    alt=""
                  />
                </Link>
              </div>
            ) :
            <div></div>
          }
        </div>
      }
    },
    {
      dataField: "productcategory",
      text: "Category",
      sort: true,
      searchable: true
    },
    {
      dataField: "productsubcategory",
      text: "Sub category",
      sort: true,
      searchable: true
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      formatter: (cellContent, item) => (
        <>
          <div className="d-flex gap-3">
            <Link
              to="#"
              className="text-success"
              onClick={(e) => {
                e.stopPropagation()
                history.push("/edit-product/"+item.productid)
              }}
            >
              <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
              <UncontrolledTooltip placement="top" target="edittooltip">
                Edit
              </UncontrolledTooltip>
            </Link>
            <Link
              to="#"
              className="text-danger"
              onClick={(e) => {
                handleDeleteClick(item)
                e.stopPropagation()
              }}
            >
              <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
              <UncontrolledTooltip placement="top" target="deletetooltip">
                Delete
              </UncontrolledTooltip>
            </Link>
          </div>
        </>
      ),
    },
  ]

  const handleDeleteClick = arg => {
    setItemToDelete(arg)
    setDeleteMessage(arg.productcode + ' - ' + arg.productname)
    setShowDeletePopUp(true)
  }

  const confirmDelete = async () =>{
    setShowDeletePopUp(false)
    setShowLoading(true)
    const response =  await onDeleteItemDirect({
      'key': itemToDelete.productid,
      'value' : 'Product'
    }, '')
    setShowLoading(false)
    if(response.status == 'success'){
      dispatch(onGetAllProducts())
      showSuccessToast('Deleted Successfully!!!')
    }
    else if(response.status == 'failure'){
      setErrorMessage(response.errorResponse)
      setShowErrorPopUp(true)
    }
  }

  const defaultSorted = [
    {
      dataField: "value",
      order: "asc",
    },
  ]

  const selectRow = {
    mode: 'radio',
    hideSelectColumn: true,
    clickToSelect: true,
    bgColor: '#e8e2d7',
    onSelect: (row, isSelect, rowIndex, e) => {
      history.push('/view-products/'+row.productid)
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>View All Products | Flamingo</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Products" breadcrumbItem="View All Products" />
          <Loader showLoader={showLoading} />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="productid"
                    columns={ProductListColumns()}
                    data={productList}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="productid"
                        data={productList}
                        columns={ProductListColumns()}
                        bootstrap4
                        search
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row className="mb-2">
                              <Col sm="4">
                                <div className={classNames({"d-none": currentPage !== 1},"search-box me-2 mb-2 d-inline-block")}>
                                  <div className="position-relative">
                                    <SearchBar {...toolkitProps.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                              <Col sm="8">
                                <div className="text-sm-end">
                                  <Link
                                    to="/add-product"
                                    role="button"
                                    className="btn btn-success btn-rounded  mb-2 me-2"
                                  >
                                    <i className="mdi mdi-plus me-1" />
                                    Add New Product
                                  </Link>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField="id"
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    selectRow={selectRow}
                                    classes={
                                      "table align-middle table-hover pointer-cursor table-check"
                                    }
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row className="align-items-md-center mt-30">
                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <ReactDrawer
        open={open}
        position={position}
        onClose={onDrawerClose}
      >
        <RightDrawer 
          onClose={onDrawerClose} 
          currentItem={newItemToAdd} 
          onNewlyAddedValue={onNewlyAddedValue}
          selectedId={null}
          detailsForEdit={detailsForEdit}
          isEdit={isEdit}
        />
      </ReactDrawer>
      {showDeletePopUp ? (
        <SweetAlert
          title="Are you sure?"
          warning
          showCancel
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            confirmDelete()
          }}
          onCancel={() => {
            setShowDeletePopUp(false)
          }}
        >
          <p>Deleting Product : <b>{deleteMessage}</b></p>
          You won't be able to revert this!
        </SweetAlert>
      ) : null}
      {showErrorPopUp ? (
        <SweetAlert
          error
          title="Failed"
          onConfirm={() => {
            setShowErrorPopUp(false)
          }}
        >
          {errorMessage}
        </SweetAlert>
      ) : null}

      {isGallery ? (
        <Lightbox
          mainSrc={selectedFiles[photoIndex]}
          nextSrc={selectedFiles[(photoIndex + 1) % selectedFiles.length]}
          prevSrc={selectedFiles[(photoIndex + selectedFiles.length - 1) % selectedFiles.length]}
          enableZoom={true}
          onCloseRequest={() => {
            setisGallery(false)
          }}
          onMovePrevRequest={() => {
            setphotoIndex((photoIndex + selectedFiles.length - 1) % selectedFiles.length)
          }}
          onMoveNextRequest={() => {
            setphotoIndex((photoIndex + 1) % selectedFiles.length)
          }}
          imageCaption={selectedFiles[photoIndex]}
        />
      ) : null}
    </React.Fragment>
  )
}

ProductList.propTypes = {
  productList: PropTypes.array,
  onGetAllProducts: PropTypes.func,
}

export default withRouter(ProductList)
